import React from 'react';
import Button from '@material-ui/core/Button';

export default function CategoriesFilterComp(props) {
  const [selecteds, setSelecteds] = React.useState([]);

  React.useEffect(() => {
    props.onCategoryChanged(selecteds);
  }, [selecteds]);

  const setSelectedHandler = (item) => {
    if (selecteds.includes(item)) {
      setSelecteds((selecteds) => selecteds.filter((_item) => item !== _item));
    } else {
      setSelecteds((selecteds) => [item]);
    }
  };

  const categories = props.categories;
  return (
    <>
      {categories.map((item) => (
        <Button
          key={item.key}
          size="small"
          variant={selecteds.includes(item.key) ? 'contained' : 'outlined'}
          color="primary"
          className={'edit-category-btn'}
          onClick={() => {
            setSelectedHandler(item.key);
          }}
        >
          {item.value}
        </Button>
      ))}
    </>
  );
}
